/* tslint:disable */

/**
 */
export class ActivityLog {
    id?: number;
    company_id?: number;
    user_id?: number;
    user_down?: string;
    action?: string;
    subject_type?: string;
    subject_data?: string;
    created_at?: string;
    updated_at?: string;
}
